import React, { useCallback } from 'react'
import noop from 'lib/function/noop'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface Props {
  onNoThanks?: () => void;
  onUpgrade?: () => void;
  children: React.ReactNode;
}

function PackageUpgradeModal({
  onNoThanks = noop,
  onUpgrade = noop,
  children,
}: Props) {
  const modalContext = useModalElementContext()

  const onUpgradeClick = useCallback(() => {
    modalContext.resolve()
    onUpgrade()
  }, [modalContext, onUpgrade])

  const onNoThanksClick = useCallback(() => {
    modalContext.resolve()
    onNoThanks()
  }, [modalContext, onNoThanks])

  return (
    <ModalBase
      size="large"
      dismissible={false}
    >
      <ModalHeader
        dismissible={false}
        title="Want to upgrade your package?"
        subtitle="Pay a little extra for a more luxurious stay."
      />
      <ModalBody>
        <ModalContent>
          {children}
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Upgrade',
          onClick: onUpgradeClick,
        }}
        secondaryActionProps={{
          children: 'No thanks',
          onClick: onNoThanksClick,
        }}
      />
    </ModalBase>
  )
}

PackageUpgradeModal.defaultProps = {
  onClose: noop,
  onNoThanks: noop,
  onUpgrade: noop,
}

export default PackageUpgradeModal
